<select
  [disabled]="false"
  class="tags"
  name="tags"
  [(ngModel)]="currentSelection"
  (ngModelChange)="changed()">
  <option [hidden]="!hint" [ngValue]="hint" hidden selected>{{hint?.getSelectionTitle()}}</option>
  <option *ngFor="let tag of tags" [ngValue]="tag.getSelectionValue()">{{tag.getSelectionTitle()}}</option>
</select>
